/**
 * Exclusões com "Desfazer": a tarefa some na hora, mas só é apagada no servidor depois de alguns
 * segundos. Se a página fechar antes, a exclusão é enviada na saída (keepalive).
 */
import { rpcBeacon } from '../lib/rpc';

interface Pending { timer: ReturnType<typeof setTimeout>; commit: () => void }
const pending = new Map<string, Pending>();

export const isPendingDelete = (id: string) => pending.has(id);
export const hasPendingDeletes = () => pending.size > 0;

/** Agenda a exclusão; devolve a função que desfaz (false se já tinha sido enviada). */
export function scheduleDelete(id: string, ms: number, commit: () => void): () => boolean {
  const p: Pending = { timer: setTimeout(() => { pending.delete(id); commit(); }, ms), commit };
  pending.set(id, p);
  return () => {
    if (pending.get(id) !== p) return false;
    clearTimeout(p.timer);
    pending.delete(id);
    return true;
  };
}

if (typeof window !== 'undefined') {
  window.addEventListener('pagehide', () => {
    for (const [id, p] of pending) { clearTimeout(p.timer); rpcBeacon('tasks.delete', { id }); }
    pending.clear();
  });
}
